export default __webpack_public_path__ + "static/illustration-5f7bd0bdb777c699b630d74a47701d1e.png";